import styles from 'src/styles/Home.module.scss';
import PageTitle from 'src/components/PageTitle';

import wrapper from 'src/modules';
import { initializeCode, initializeRestaurant } from 'src/modules/Restaurant';
import { initializeFingerprint } from 'src/modules/User';
import { detectLanguage } from 'src/utils/language';
import getUserFp from 'src/utils/userFp';

import RestaurantMenu from 'src/components/RestaurantMenu';

export const getServerSideProps = wrapper.getServerSideProps((store) => async (ctx) => {
    const { slug, context, token } = ctx.query;
    const { lang } = detectLanguage(ctx);

    const fp = getUserFp(ctx);

    await initializeFingerprint(fp)(store.dispatch);

    let result = null;

    if (context) {
        result = await initializeCode(context, fp, token, lang)(store.dispatch);
    } else {
        result = await initializeRestaurant(slug, fp, token, lang)(store.dispatch);
    }

    if (result?.statusCode) {
        ctx.res.statusCode = result?.statusCode;
    }

    return {};
});

const HashPage = () => (
    <div className={styles.container} id="home">
        <PageTitle />
        <RestaurantMenu />
    </div>
);

export default HashPage;
